// filepath: c:\Users\James\invent-sales-center-new\src\views\AdminPage\Analytics\AnalyticsChartWrapper.tsx
import React, { ReactNode } from 'react'
import { useAnalyticsScreenShare } from './AnalyticsScreenShareContext'

interface AnalyticsChartWrapperProps {
    title?: string
    className?: string
    children: ReactNode
}

export function AnalyticsChartWrapper(props: AnalyticsChartWrapperProps) {
    const {
        title,
        className = '',
        children,
    } = props
    const screenShare = useAnalyticsScreenShare()

    const wrapperStyle = {
        ['--analytics-screen-share-context-zoom' as any]: String(screenShare?.zoom ?? 1),
    }

    return (
        <div
            className={`analytics-chart-wrapper ${className}${screenShare?.isActive ? ' screen-share-active' : ''}`}
            style={wrapperStyle}
            data-screen-share-active={screenShare?.isActive ? '1' : '0'}
        >
            {title && <h3>{title}</h3>}
            <div className="chart-container">
                {children}
            </div>
        </div>
    )
}